import defaults from './defaults';
import overrides from './overrides';
import defaultsDeep from '~/utils/defaultsDeepES';

export default defaultsDeep(overrides, defaults) as typeof defaults;
